export default __webpack_public_path__ + "static/media/caret-white.79717a9d.svg";